import {createSelector} from 'reselect';
import {isTheSignActor} from "../../services/sign-actors";

const reports = state => state.reports.list;
const openReportList = state => state.reports.openReportList;
const userContext = state => state.common.userContext;

const isViewingReport = state => state.trainingPhases.isViewingReport;

const openReportsCount = createSelector(
  reports,
  reports =>
    (reports ? reports.filter(report => !report.getIsCompleted()).length : null),
);

const getSelectedReport = (reports, openReportList, reportGuid) => {
  let selected = null
  if(reports) {
    selected = reports.find((report) => {
      return report.guid === reportGuid;
    })
  }
  if(!selected && openReportList) {
    selected = openReportList.find((report) => {
      return report.guid === reportGuid;
    })
  }
  if (!selected) {
    return null;
  }
  return selected;
};

const viewingReport = createSelector(
  [reports, openReportList, isViewingReport],
  getSelectedReport,
);

const reportsWaitingAcknowledgement = createSelector(
  reports,
  userContext,
  (reports, userContext) =>
    reports
    && reports.filter(report =>
    report.getCanAcknowledge(userContext.scope)
    && (report.getIsAckDueFuture() || report.getIsAckDueNow() || report.getIsAckDueToday())
    ),
);

const reportsDueAcknowledgement = createSelector(
  reports,
  userContext,
  (reports, userContext) =>
    reports &&
    reports.filter(report => report.getCanAcknowledge(userContext.scope) && report.getIsLateAck()),
);

const reportsDueAcknowledgementOit = createSelector(
  reports,
  userContext,
  (reports, userContext) =>
    reports &&
    reports.filter(report => report.getCanAcknowledge('oit') && report.getIsLateAck()),
);

const reportsDraftFto = createSelector(
  reports,
  userContext,
  (reports, userContext) => {
    return reports &&
    reports.filter(report => report.status === 'draft' && report.author && report.author.authorGuid === userContext.userGuid)
  },
);

const reportsWaitingSubmit = createSelector(
  reports,
  userContext,
  (reports, userContext) =>
    reports &&
    reports.filter(report => {
      return (report.status === 'scheduled' || report.status === 'draft' || report.status === 'rejected')
        && report.getCanSubmit(userContext.scope)
        && report.getIsUserAuthor(userContext.userGuid)
        && (report.getIsDueInFuture() || report.getIsDueToday() || report.getIsDueNow())
    }).sort((report1, report2) => {
      if (report1.status !== report2.status && report1.status === 'rejected') {
        return -1
      }
      if (report1.status !== report2.status && report2.status === 'rejected') {
        return 1
      }

      return 0
    })
);

const reportsDueSubmit = createSelector(reports, userContext, (reports, userContext) => {
  return (
    reports &&
    reports.filter(report =>
      ((report.status === 'scheduled' || report.status === 'draft' ||  report.status === 'rejected')
        && report.getCanSubmit(userContext.scope)
        && report.getIsUserAuthor(userContext.userGuid)
        && report.getIsLate()
      )
    ).sort((report1, report2) => {
      if (report1.status !== report2.status && report1.status === 'rejected') {
        return -1
      }
      if (report1.status !== report2.status && report2.status === 'rejected') {
        return 1
      }

      return 0
    })
  );
});

const reportsDueSubmitForScope = (scope) => createSelector(reports, (reports) => {
  return (
    reports &&
    reports.filter(report =>
      (report.status === 'scheduled' || report.status === 'draft' || report.status === 'rejected')
      && report.getCanSubmit(scope)
      && report.getIsLate())
  );
});


const reportsWaitingApprove = createSelector(
  reports,
  userContext,
  (reports, userContext) => userContext && reports && reports.filter(report => {
    return (report.getCanApprove(userContext.scope) || report.getCanApproveTwo(userContext.scope) || report.getCanApproveThree(userContext.scope) || report.getCanApproveFour(userContext.scope) || report.getCanApproveFive(userContext.scope))
      && (report.getIsApprovalDueFuture() || report.getIsApprovalDueNow() || report.getIsApproveTwoDueInFuture() || report.getIsApproveTwoDueNow() || report.getIsApproveThreeDueInFuture() || report.getIsApproveThreeDueNow() || report.getIsApproveFourDueInFuture() || report.getIsApproveFourDueNow() || report.getIsApproveFiveDueInFuture() || report.getIsApproveFiveDueNow())
      && (
        (report.isNextSignAvailable('approve_one') && isTheSignActor(userContext.userGuid, report, report.type, 'approverOne'))
        || (report.isNextSignAvailable('approve_two') && isTheSignActor(userContext.userGuid, report, report.type, 'approverTwo'))
        || (report.isNextSignAvailable('approve_three') && isTheSignActor(userContext.userGuid, report, report.type, 'approverThree'))
        || (report.isNextSignAvailable('approve_four') && isTheSignActor(userContext.userGuid, report, report.type, 'approverFour'))
        || (report.isNextSignAvailable('approve_five') && isTheSignActor(userContext.userGuid, report, report.type, 'approverFive'))
      )
  })
);

const reportsDueApprove = createSelector(reports, userContext, (reports, userContext) => {
  return reports && reports.filter(report => {
      return (report.getCanApprove(userContext.scope) || report.getCanApproveTwo(userContext.scope) || report.getCanApproveThree(userContext.scope) || report.getCanApproveFour(userContext.scope) || report.getCanApproveFive(userContext.scope))
        && (report.getIsLateApproval() || report.getIsApproveTwoIsLate() || report.getIsApproveThreeIsLate() || report.getIsApproveFourIsLate() || report.getIsApproveFiveIsLate())
        && (
          (report.isNextSignAvailable('approve_one') && isTheSignActor(userContext.userGuid, report, report.type, 'approverOne'))
          || (report.isNextSignAvailable('approve_two') && isTheSignActor(userContext.userGuid, report, report.type, 'approverTwo'))
          || (report.isNextSignAvailable('approve_three') && isTheSignActor(userContext.userGuid, report, report.type, 'approverThree'))
          || (report.isNextSignAvailable('approve_four') && isTheSignActor(userContext.userGuid, report, report.type, 'approverFour'))
          || (report.isNextSignAvailable('approve_five') && isTheSignActor(userContext.userGuid, report, report.type, 'approverFive'))
        )
    }
  );
});

const reportsWaitingReview = createSelector(reports, userContext, (reports, userContext) => {
  return reports && reports.filter(report =>
    report.getCanApproveTwo(userContext.scope)
    && (report.getIsApproveTwoDueNow() || report.getIsApproveTwoDueInFuture() || report.getIsApproveTwoIsLate())
    && isTheSignActor(userContext.userGuid, report, report.type, 'approverTwo'));
});

const reportsDueReview = createSelector(reports, userContext, (reports, userContext) => {
  return reports && reports.filter(report =>
    report.getCanApproveTwo(userContext.scope)
    && report.getIsApproveTwoIsLate()
    && isTheSignActor(userContext.userGuid, report, report.type, 'approverTwo'));
});

const reportsDueSubmitForFto = reportsDueSubmitForScope('fto');

export {
  openReportsCount,
  viewingReport,
  reportsWaitingAcknowledgement,
  reportsDueAcknowledgement,
  reportsDueAcknowledgementOit,
  reportsWaitingSubmit,
  reportsDueSubmit,
  reportsWaitingApprove,
  reportsDueApprove,
  reportsWaitingReview,
  reportsDueReview,
  reportsDueSubmitForFto,
  reportsDraftFto
};
